// Adult vital sign range evaluator.
// Returns { level, msg } where level is "normal" | "low" | "high",
// or null if the value is empty/unparseable.
//
// Reference adult ranges used:
//   FC:    60-100 lpm
//   Temp:  36.0-37.4 C (37.5-37.9 febricula, >=38 fiebre)
//   SpO2:  >=95 % normal; 90-94 alerta; <90 critico
//   T/A:   sistolica 90-140, diastolica 60-90

export function evaluateFC(v) {
  if (v === "" || v == null) return null;
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  if (n < 60) return { level: "low", msg: "Bradicardia" };
  if (n > 100) return { level: "high", msg: "Taquicardia" };
  return { level: "normal" };
}

export function evaluateTemp(v) {
  if (v === "" || v == null) return null;
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  if (n < 36) return { level: "low", msg: "Hipotermia" };
  if (n >= 38) return { level: "high", msg: "Fiebre" };
  if (n >= 37.5) return { level: "high", msg: "Febricula" };
  return { level: "normal" };
}

export function evaluateSpO2(v) {
  if (v === "" || v == null) return null;
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  if (n < 90) return { level: "low", msg: "Hipoxia" };
  if (n < 95) return { level: "low", msg: "SpO2 bajo" };
  return { level: "normal" };
}

export function evaluateTA(v) {
  if (!v) return null;
  const m = String(v).trim().match(/^(\d{2,3})\s*\/\s*(\d{2,3})$/);
  if (!m) return null;
  const sys = parseInt(m[1], 10);
  const dia = parseInt(m[2], 10);
  if (sys < 90 || dia < 60) return { level: "low", msg: "Hipotension" };
  if (sys > 140 || dia > 90) return { level: "high", msg: "Hipertension" };
  return { level: "normal" };
}

export function evaluateVital(field, value) {
  switch (field) {
    case "ta": return evaluateTA(value);
    case "fc": return evaluateFC(value);
    case "temp": return evaluateTemp(value);
    case "spo2": return evaluateSpO2(value);
    default: return null;
  }
}

// True if the value is captured and is outside the normal range
export function isAbnormal(field, value) {
  const e = evaluateVital(field, value);
  return e !== null && e.level !== "normal";
}
